export class RequestHeaderTo{
    name: String;
    value: String;
    
    constructor(object?: any) {
        if (object) {
            this.name = object.name;
            this.value = object.value;
        }
    }
}